import { render } from "./ToepButtons.vue?vue&type=template&id=4cf27020"
import script from "./ToepButtons.vue?vue&type=script&lang=js"
export * from "./ToepButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__